import CheckMarkIcon from '@atlaskit/icon/core/check-mark';
import { Inline, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import React from 'react';

import type { MenuItem } from './types.ts';

const hiddenStyles = xcss({ visibility: 'hidden' });

const checkmarkIcon = (
  <CheckMarkIcon label="" color={token('color.text.brand', '#0C66E4')} />
);

export const getMenuItemIcon = (
  item: Pick<MenuItem, 'isChecked' | 'elemBefore'>,
  hasCheckedSibling: boolean
): React.ReactElement | undefined => {
  if (item.isChecked === undefined) {
    return item.elemBefore;
  }
  if (item.isChecked) {
    return checkmarkIcon;
  }
  // Reserve space if a sibling is checked, to preserve alignment
  if (hasCheckedSibling) {
    return (
      <Inline xcss={hiddenStyles} testId="hidden-checkmark">
        {checkmarkIcon}
      </Inline>
    );
  }
  return item.elemBefore;
};
